module.exports = __webpack_public_path__ + "img/img.71253947.png";